import { LinearProgress } from "@mui/material"

const MLUProgressBar = LinearProgress

export default MLUProgressBar
